// @flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { createAndProvision } from 'client/actions/enterprise/user';
import { createWithResources } from 'client/actions/user';
import CreatePage from './createPage';

const mapStateToProps: Object = ({ siteConfigs, translations }, ownProps) => {
  const query = _.get(ownProps, 'location.query', {});
  const { code, redirect, id } = query;
  return {
    code,
    redirect,
    siteConfigs,
    translations,
    id,
  };
};

export default connect(mapStateToProps, { createAndProvision, createWithResources })(CreatePage);
